<script>
import Layout from '@/views/layouts/main';
import appConfig from '@/app.config';
import Swal from 'sweetalert2';
import LoadingIcon from '@/components/Loading/main.vue';
import i18n from '@/i18n';

import { masterMethods } from '@/state/helpers';
import { checkPermission } from '@/utils/handlers';
import { showMessage } from '@/utils/messages';

export default {
    page: {
        title: i18n.t('sheduleFile.list'),
        meta: [{ name: 'description', content: appConfig.description }]
    },
    components: {
        Layout,
        LoadingIcon
    },
    data() {
        return {
            loading: false,
            listData: [],
            isLoading: false
        };
    },

    mounted() {
        this.getListMasterScheduleFile();
    },
    methods: {
        checkPermission,
        ...masterMethods,
        async getListMasterScheduleFile() {
            this.isLoading = true;
            try {
                const dataRespone = await this.getListScheduleFile();
                this.listData = dataRespone.data;
                this.isLoading = false;
            } catch (error) {
                this.isLoading = false;
            }
        },
        checkPermiss(listRole) {
            return checkPermission(listRole);
        },
        handleEdit(idRecord) {
            this.$router.push({
                path: '/master/schedule/add',
                query: {
                    id: idRecord
                }
            });
        },
        handleDelete(k) {
            Swal.fire({
                title: '削除してもよろしいですか。',
                text: '',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#34c38f',
                cancelButtonColor: '#e8ecf4',
                confirmButtonText: 'OK',
                cancelButtonText: 'キャンセル'
            }).then((result) => {
                if (result.value) {
                    this.deleteScheduleFile(k).then((data) => {
                        if (data.code == 200) {
                            this.getListMasterScheduleFile();
                            showMessage(data.code, this.$bvToast, '削除されました。');
                        }
                    });
                }
            });
        }
    }
};
</script>

<template>
    <Layout>
        <div v-if="listData.length > 0 && !isLoading">
            <div class="col-lg-12">
                <div class="card" style="min-height: 100vh">
                    <div class="card-body">
                        <div class="text-right mb-3">
                            <button
                                v-if="checkPermission('master.register')"
                                class="btn btn-common btn-primary"
                                @click="
                                    () => {
                                        this.$router.push({ path: '/master/schedule/add' });
                                    }
                                "
                            >
                                {{ $t('sheduleFile.resgister') }}
                            </button>
                        </div>
                        <div v-for="item in listData" :key="item.id">
                            <div class="d-flex align-items-start mt-3">
                                <div class="w-100">
                                    <div class="d-flex">
                                        <input :disabled="true" class="form-control" v-model="item.title" />
                                        <button
                                            v-if="checkPermission('master.edit')"
                                            type="button"
                                            @click="handleEdit(item.id)"
                                            class="btn btn-common-sml btn-primary ml-2"
                                            style="white-space: nowrap"
                                        >
                                            <i class="ri-edit-box-line"></i>{{ $t('btn.edit') }}
                                        </button>
                                        <button
                                            v-if="checkPermission('master.delete')"
                                            type="button"
                                            @click="handleDelete(item)"
                                            class="btn btn-common-sml btn-danger ml-2"
                                            style="white-space: nowrap"
                                        >
                                            <i class="ri-delete-bin-2-line"></i>{{ $t('btn.delete') }}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="d-flex justify-content-center" v-else>
            <LoadingIcon />
        </div>
    </Layout>
</template>
<style></style>
